import { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Trash2 } from 'lucide-react';
import { api } from '../services/api';

export function PoiListManager({ storeId, refreshKey }: { storeId: string; refreshKey?: number }) {
  const [pois, setPois] = useState<any[]>([]);

  const fetchPois = async () => {
    try {
      const data = await api.getStorePois(storeId);
      setPois(data);
    } catch (err) {
      console.error(err);
    }
  };

 useEffect(() => { fetchPois(); }, [storeId, refreshKey]);

  const handleDelete = async (poiId: string) => {
    if (!confirm('Delete this POI?')) return;
    try {
      await api.deletePOI(poiId);
      fetchPois();
    } catch (err) {
      alert('Failed to delete POI');
    }
  };

  return (
    <div className="border rounded divide-y max-h-60 overflow-y-auto">
      {pois.length === 0 && <p className="p-3 text-sm text-muted-foreground">No POIs</p>}
      {pois.map(poi => (
        <div key={poi.id} className="flex items-center justify-between p-2">
          <div className="flex items-center gap-2">
            <img src={poi.photoUrl} className="w-8 h-8 rounded-full object-cover" onError={(e) => (e.currentTarget.style.display='none')} />
            <span className="text-sm font-mono">{poi.code}</span>
          </div>
          <Button size="sm" variant="destructive" onClick={() => handleDelete(poi.id)}>
            <Trash2 className="w-3 h-3" />
          </Button>
        </div>
      ))}
    </div>
  );
}
